import LimitPrice from "components/Slider_Mui/SliderMui"
import { useState, useEffect } from "react"
import { Input } from "antd"
import Label from "components/Label"
import Button from "components/Button"
import { getAll } from 'services/infoAddressServices'

import { FilterWrapper } from "./styled"

const Filter = ({
    setMinPrice,
    setMaxPrice,
    handleChangeProvince,
    provinceInit,
    person,
    handleChangePerson,
    handleChangeSortPrice,
    sortPrice,
    handleSubmitSort
}) => {

    const defaultValueMin = 0
    const defaultValueMax = 50000000
    const handleChangeLimitPrice = (e) => {
        setMinPrice((e.target.value)[0])
        setMaxPrice((e.target.value)[1])
    }
    const [province, setProvince] = useState([])

    useEffect(() => {
        const loadAddress = async () => {
            const result = await getAll()
            setProvince(result)
        }
        loadAddress()

    }, [])
    return (
        <FilterWrapper>
            <div className="filter_item">
                <div className="limit_price">
                    <Label className="mr-20">Khoảng giá:</Label>
                    <LimitPrice
                        defaultValueMin={defaultValueMin}
                        defaultValueMax={defaultValueMax}
                        minValue={0}
                        maxValue={50000000}
                        step={2}
                        handleChangeValue={handleChangeLimitPrice}
                    />
                </div>
                <div className="ml-25">
                    <Label>Số người:</Label>
                    <Input
                        className="input_person ml-10"
                        type="number"
                        min={0}
                        value={person !== "all" && !isNaN(parseInt(person)) ? person : ""}
                        onChange={handleChangePerson}
                    />
                </div>
                <div className="ml-25 button_control">
                    <Button className="action-danger btn-filter" onClick={handleSubmitSort}>Lọc</Button>
                </div>
            </div>
            <div className="filter_item">
                <div className="province">
                    <Label className="mr-10">Tỉnh/Thành phố:</Label>
                    <select value={provinceInit} onChange={handleChangeProvince}>
                        <option value="all">Tất cả</option>
                        {
                            province?.map((item, index) => (
                                <option key={index} value={item.code}>{item.name}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="price ml-25">
                    <Label className="mr-10">Giá:</Label>
                    <select onChange={handleChangeSortPrice} value={sortPrice}>
                        <option value="final_price ASC">Thấp đến cao</option>
                        <option value="final_price DESC">Cao xuống thấp</option>
                    </select>
                </div>
            </div>
        </FilterWrapper>
    )
}

export default Filter